/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11.516 1a.5.5 0 01.5.5l-.001.5H14a1 1 0 011 1v11a1 1 0 01-1 1H2a1 1 0 01-1-1V3a1 1 0 011-1h1.991v-.5a.5.5 0 011 0V2h6.024v-.5a.5.5 0 01.5-.5zM14 6H2v8h12V6zm-8.5 5a.5.5 0 010 1h-1a.5.5 0 010-1h1zm3 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm3 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm-6-3a.5.5 0 010 1h-1a.5.5 0 010-1h1zm3 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm3 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zM3.991 3H2v2h12V3h-1.985v.5a.5.5 0 01-1 0V3H4.991v.5a.5.5 0 01-1 0V3z" _fill="#5B6881"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/calendar.js